import translations_ENGLISH from '../resources/translations/GB.json';
import translations_DUTCH from '../resources/translations/NL.json';
import translations_FRENCH from '../resources/translations/FR.json';
import translations_GREEK from '../resources/translations/GR.json';
import { getLanguage } from './GNRL';
import { store } from '../../Store';

translations_GREEK['no_items'] = '    Δέν υπάρχουν δεδομένα';
translations_ENGLISH['no_items'] = '    No data';

export function translateStatic(value) {
    let lang = getLanguage();

    switch (lang) {
        case 'en':
            return translations_ENGLISH[value];
        case 'nl':
            return translations_DUTCH[value];
        case 'fr':
            return translations_FRENCH[value];
        case 'el':
        case 'gr':
            return translations_GREEK[value];
        default:
            return translations_ENGLISH[value];
    }
}

// String.prototype.translate = translateStatic; THIS ISNT FP BECASE, GET THIS: YOU'RE MUTATING THE ENV OBJECT!! nice way to think about it. also practically it might mess up because globals but you know..
export function translate(value) {
    var translated = translateStatic(value);
    if (!translated) {
        return translateLookupEverything(value);
    }

    return translated
        .replace('%%app%%', getAppTranslation())
        .replace('%%app%%', getAppTranslation());
}

const getAppTranslation = () => {
    return 'novoville';
};

function translateLookupEverything(value) {
    const translations = store.getState().translationsReducer.translations;
    for (var key in translations) {
        if (translations[key][value]) {
            return translations[key][value];
        }
    }
    return value;
}

export function translateAPICode(value) {
    const translations = store.getState().translationsReducer.translations;
    return translations.responses[value];
}
